/**
 * ===================================================================================================
 * modalConstants.js - 모달 컴포넌트 전반에 걸쳐 사용되는 상수 정의 파일
 * ===================================================================================================
 *
 * 📍 위치: 프론트엔드 > client/src/components/modals/constants/modalConstants.js
 *
 * 🎯 주요 기능:
 *    - 요일 및 학년부에 대한 일관된 레이블(한글)과 내부 코드(영문) 매핑을 제공.
 *    - UI 표시 및 데이터 처리 시 표준화된 값을 사용하도록 지원.
 *
 * 🔗 연결된 파일:
 *    - ../components/ScheduleCard.js - 학년부 레이블을 표시할 때 `GRADE_LEVEL_LABELS` 사용.
 *    - 다양한 모달 및 관련 로직에서 요일 및 학년부 데이터 파싱 및 표시를 위해 사용.
 *
 * 💡 사용처:
 *    - 사용자에게 요일이나 학년 정보를 한글로 보여줄 때 (`DAY_LABELS`, `GRADE_LEVEL_LABELS`).
 *    - 사용자 입력(한글)을 내부적으로 처리하는 영문 코드로 변환할 때 (`DAY_MAP`, `GRADE_LEVEL_MAP`).
 *
 * ✏️ 수정 가이드:
 *    - 새로운 요일 또는 학년부가 추가될 경우, 해당 상수 객체에 새로운 매핑을 추가합니다.
 *    - 기존 레이블이나 매핑이 변경될 경우, 이 파일에서 수정하여 프로젝트 전체에 일관성을 유지합니다.
 *
 * 📝 참고사항:
 *    - 이 파일의 상수는 주로 `ScheduleOptimizationModal` 및 그 하위 컴포넌트에서 활용됩니다.
 *
 * ===================================================================================================
 */

/**
 * 요일 레이블 매핑
 * @constant
 * @type {object}
 */
export const DAY_LABELS = {
  MON: '월요일',
  TUE: '화요일',
  WED: '수요일',
  THU: '목요일',
  FRI: '금요일',
  SAT: '토요일',
  SUN: '일요일'
};

/**
 * 학년부 레이블 매핑
 * @constant
 * @type {object}
 */
export const GRADE_LEVEL_LABELS = {
  elementary: '초등부',
  middle: '중등부',
  high: '고등부'
};

/**
 * 요일 맵 (한글/영문 -> 영문 코드)
 * @constant
 * @type {object}
 */
export const DAY_MAP = {
  '월요일': 'MON', '화요일': 'TUE', '수요일': 'WED', '목요일': 'THU',
  '금요일': 'FRI', '토요일': 'SAT', '일요일': 'SUN',
  '월': 'MON', '화': 'TUE', '수': 'WED', '목': 'THU',
  '금': 'FRI', '토': 'SAT', '일': 'SUN'
};

/**
 * 학년부 맵 (한글 -> 영문 코드)
 * @constant
 * @type {object}
 */
export const GRADE_LEVEL_MAP = {
  '초등부': 'elementary', '중등부': 'middle', '고등부': 'high',
  '초등': 'elementary', '중등': 'middle', '고등': 'high'
};
